// extracted by mini-css-extract-plugin
export default {"cardHouse":"CardXl_cardHouse__QutRK","cardImg":"CardXl_cardImg__2DwZp","cardHouseTitle":"CardXl_cardHouseTitle__6837e","cardHouseTitleMask":"CardXl_cardHouseTitleMask__aY5h4"};